module.exports = __webpack_public_path__ + "img/sav_logo.76da151.svg";